module.exports = __webpack_public_path__ + "img/avatar-2.a096c638.jpg";